module.exports = __webpack_public_path__ + "img/info_sp_08.d88bb383.png";